export enum TrackingEvent {
  Created = `Created `,
  CreateFailed = `Create failed`,
  LinkClicked = `Link clicked`,
  SubmitFeedback = `Submit Feedback`,
  Copied = `Copied`,
  Closed = `Closed`,
}
